<script setup>

import {onMounted, reactive, ref, watch} from "vue";

const emit = defineEmits(['targetSelected']);
const props = defineProps({
    selectedTarget: Number
})

const targets = reactive({
    pages: [],
})
const target = ref(null)

const loadTargets = async () => {
    const res = await axios.get(route('api.manage-whitelabel-app.navigation-targets'))
    targets.pages = res.data.pages

    setCurrentTarget()
}

const setCurrentTarget = () => {
    if (props.selectedTarget) {
        const current = targets.pages.find(t => t.id === props.selectedTarget)
        if (current) {
            target.value = current.id
            emit('targetSelected', current.id)
        }
    } else {
        target.value = null
    }
}

const setTarget = (target) => {
    target.value = target;
    emit('targetSelected', target.id)
}

watch(() => props.selectedTarget, () => {
    setCurrentTarget()
})

onMounted(() => {
    loadTargets()
})

</script>

<template>
    <ul class="-mx-4 lg:-mx-6 bg-gray-100 border-y py-3 mt-2 max-h-96 overflow-y-scroll">
        <li
            v-for="(t, i) in targets.pages"
            :key="i"
            @click="setTarget(t)"
            class="cursor-pointer py-1 hover:bg-gray-200 px-4 lg:px-6 truncate"
            :class="target === t.id ? 'bg-gray-200 font-bold' : ''"
        >
            {{ t.title }}
        </li>
    </ul>
</template>

<style scoped>

</style>
